import { Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { UserAgentService } from "../../services/user-agent.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { HttpService } from "src/app/shared/services/httpService.service";
import { CommonService } from "src/app/shared/services/common.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NotificationsEmailTempService } from "../../services/notification-template-service";
import Swal from "sweetalert2";


@Component({
  selector: 'app-email-templat-place',
  templateUrl: './email-templat-place.component.html',
  styleUrls: ['./email-templat-place.component.scss']
})
export class EmailTemplatPlaceComponent {
  public pageDropdownMenu: any = [10, 20, 30];
  public itemsPerPage: number = 10;
  public totalItems: number;
  currentPage: number = 1;
  totalPages: number = 1;
  userList: any;
  public first_page_url: any = "";
  public last_page_url: any = "";
  initials: any;
  public next_page_url: any = "";
  totalusers: number;
  tagForm: FormGroup;
  modalRef: any;
  tagId: any;
  showmodal: boolean = false;
  tagTypeList: any;
  isSkeletonLoader: boolean = true;
  constructor(
    private fb: FormBuilder,
    private userAgentService: UserAgentService,
    private _snackBar: MatSnackBar,
    private router: Router,
    private http: HttpService,
    private commonService: CommonService,
    private modalService: NgbModal,
    private notifationTempService: NotificationsEmailTempService
  ) {}
  @ViewChild("tagModal") tagModal;

  ngOnInit(): void {
    this.tagForm = this.fb.group({
      placeholderName: ['', Validators.required], 
      description: [''],
      isCommon: [1], 
      isTemplateSpecific:[0]
    });
    this.getUserList();
    this.getTagType();
  }

  getTagType(search?) {
    let itemsPerPage = this.itemsPerPage;
    let obj = {
      per_page: itemsPerPage,
      page: this.currentPage,
    };
    this.notifationTempService.getTemplateList(search, obj).subscribe((res: any) => {
      this.tagTypeList = res?.data?.data;
    });
  }
  getUserList(search?) {
    let itemsPerPage = this.itemsPerPage;
    let obj = {
      per_page: itemsPerPage,
      page: this.currentPage,
      searchTerm:search ? search :""
    };
    this.notifationTempService.getTemplatetPlaceholders(obj).subscribe((res: any) => {
      this.userList = res?.data?.data;
      this.totalusers = res?.data?.total;
      this.totalItems = res.data.total;
      this.currentPage = res.data.current_page;
      this.first_page_url = res.data.first_page_url;
      this.last_page_url = res.data.last_page_url;
      this.next_page_url = res.data.next_page_url;
    });
    setTimeout(() => {
      this.isSkeletonLoader = false;
    }, 1500);
    // this.loadUser=false
  }
  onChangeNumberOfPage() {
    this.getUserList();
  }
  pageChange(event) {
    this.currentPage = event;
    this.getUserList();
  }
 
  back() {
    this.router.navigateByUrl(`/user-settings`);
  }
  filterdData(event: any) {
    let data = event.target.value;
    this.getUserList(data);
    // console.log('getUser data: ',this.getUserList(data))
  }

  deleteTag(id: number) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You won’t be able to revert this!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
    }).then((result) => {
      if (result.isConfirmed) {
        this.notifationTempService.DeletePlaceholder(id).subscribe(
          (res: any) => {
            if (res.Status) {
              this.commonService.showToast('success', 'Success', res.data);
              this.getUserList();
            } else {
              this.commonService.showToast('error', 'Error', 'Something went wrong');
            }
          },
          (error) => {
            this.commonService.showToast('error', 'Error', 'Failed to delete resource');
            console.error('API error:', error);
          }
        );
      }
    });
  }
  openModal() {
    if (this.showmodal) {
      this.tagForm.reset()
    }
    this.showmodal = false;
    this.modalRef = this.modalService.open(this.tagModal, { centered: true });
  }
  editRouter(user:any){
    this.tagForm.patchValue({
      description:user.description,
      placeholderName:user.placeholder_name

    });
    this.tagId = user.id
    this.showmodal = true

   this.modalRef= this.modalService.open(this.tagModal, { centered: true });
  }
  saveTagData() {
    if (this.tagForm.valid) {
      const data = this.tagForm.value;
      if (!this.showmodal) {
        this.notifationTempService.createTemplatePlaceholder(data).subscribe(
          (res: any) => {
            if (res.Status) {
              this.commonService.showToast("success", "Success", res?.message);
              this.modalRef.close();
              this.getUserList();
            } else {
              this.commonService.showToast(
                "error",
                "Error",
                "Something went wrong"
              );
            }
          },
          (error) => {
            this.commonService.showToast(
              "error",
              "Error",
              "Failed to add resource"
            );
            console.error("API error:", error);
          }
        );
      } else {
        this.notifationTempService.UpdatePlaceholder(data, this.tagId).subscribe(
          (res: any) => {
            if (res.Status) {
              this.commonService.showToast("success", "Success", res.message);
              this.getUserList();
            } else {
              this.commonService.showToast(
                "error",
                "Error",
                "Something went wrong"
              );
            }
          },
          (error) => {
            this.commonService.showToast(
              "error",
              "Error",
              "Failed to add resource"
            );
            console.error("API error:", error);
          }
        );
      }
    } else {
      console.log("Form is invalid");
    }
  }
}
